import { render, staticRenderFns } from "./SettingsIndex.vue?vue&type=template&id=05fdcd71&"
import script from "./SettingsIndex.vue?vue&type=script&lang=js&"
export * from "./SettingsIndex.vue?vue&type=script&lang=js&"
import style0 from "./SettingsIndex.vue?vue&type=style&index=0&id=05fdcd71&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports